import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { PageContent } from '@deere/fuel-react/PageContent.js';
import { PageHeader } from '@deere/fuel-react/PageHeader.js';
import { PageHeaderTitle } from '@deere/fuel-react/PageHeaderTitle.js';

export default function App404() {
  const navigate = useNavigate();
  function goBack() {
    navigate('/');
  }
  return (
    <>
      <PageHeader>
        <PageHeaderTitle>
          <Typography variant="h1">404 Page Not Found</Typography>
        </PageHeaderTitle>
      </PageHeader>
      <PageContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: (theme) => theme.fuel6Tokens.JddcSpacingLarge
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: (theme) => theme.fuel6Tokens.JddcSpacingXSmall
          }}
        >
          <fuel-icon name="error_outlined" />
          <Typography variant="h3">This page does not exist.</Typography>
        </Box>
        <Button variant="primary" onClick={goBack}>
          Back Home
        </Button>
      </PageContent>
    </>
  );
}
